import Logo from 'assets/img/ttlogowithname.svg?react'

export const Brand = () => {
  return <Logo width={100} height={70} />
}
